module.exports = __webpack_public_path__ + "img/file-post.04bcd092.svg";